import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import ticketsReducer from './slices/ticketsSlice';
import clientsReducer from './slices/clientsSlice';
import decodingAgentReducer from './slices/decodingAgentSlice';
import alertsReducer from './slices/alertsSlice';
import correlationsReducer from './slices/correlationsSlice';
import usersReducer from './slices/usersSlice';
import integrationDataReducer from './slices/integrationDataSlice';
import notificationsReducer from './slices/notificationsSlice';
import iocsReducer from './slices/iocsSlice';
import playbooksReducer from './slices/playbooksSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    tickets: ticketsReducer,
    clients: clientsReducer,
    decodingAgent: decodingAgentReducer,
    alerts: alertsReducer,
    correlations: correlationsReducer,
    users: usersReducer,
    integrationData: integrationDataReducer,
    notifications: notificationsReducer,
    iocs: iocsReducer,
    playbooks: playbooksReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['auth/login/fulfilled', 'auth/register/fulfilled', 'auth/refresh/fulfilled'],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
